export const tabTaxGroups = {
	addNewTaxGroup: "Agregar nuevo grupo",
	emptyTaxGroupsMessage: "No existen grupos fiscales de producto para mostrar",
	infosTaxGroup: {
		aliquot: "Alícuota",
		cfop: "CFOP",
		tax: "Tax",
		type: "Tipo",
	},
	searchPlaceholder: "Buscar grupos fiscales de producto",
	typeLabel: {
		invoice: "Factura",
		service: "Servicio",
		vat: "Value Added Tax",
	},
};
